// extracted by mini-css-extract-plugin
export default {"setPoseFloatingBtn":"SetPoseFloatingButton_setPoseFloatingBtn__4-sdA","setPoseFloatingBtnActive":"SetPoseFloatingButton_setPoseFloatingBtnActive__CtTj1"};